import { AppUtils } from '../../utils/index';

import { BaseApiModel } from './BaseApiModel';
import { IUserExtApi } from './InterfacesIUserExtApi';
import { AdacResultMessageApi } from './TypesAdacResultMessageApi';

/**
 * APIL Url: ADAC.Internet.WebApi.Models.AdacIdentityModel
 * Antwortobjekt für den Identitäts-Controller
 * Endpoints: /api/Identity, /api/Identity/IdentUnverified
 */
export class AdacIdentityModelApi extends BaseApiModel {
	constructor(initialProperties?: Partial<AdacIdentityModelApi>) {
		super();
		if (initialProperties) {
			AppUtils.Helper.mapObject(initialProperties, this);
		}
	}

	protected userData: IUserExtApi;
	/**
	 * Description: 
	 * APIL Type: ADAC.Internet.Interfaces.IUserExt
	 */
	get UserData(): IUserExtApi {
		return this.userData;
	}

	/**
	 * Description: 
	 * APIL Type: ADAC.Internet.Interfaces.IUserExt
	 */
	set UserData(value: IUserExtApi) {
		this.userData = value;
	}

	protected iD: string;
	/**
	 * Description: 
	 * APIL Type: uuid
	 */
	get ID(): string {
		return this.iD;
	}

	/**
	 * Description: 
	 * APIL Type: uuid
	 */
	set ID(value: string) {
		this.iD = value;
	}

	protected mglNo: string;
	/**
	 * Description: 
	 * APIL Type: string
	 */
	get MglNo(): string {
		return this.mglNo;
	}

	/**
	 * Description: 
	 * APIL Type: string
	 */
	set MglNo(value: string) {
		this.mglNo = value;
	}

	protected loginName: string;
	/**
	 * Description: 
	 * APIL Type: string
	 */
	get LoginName(): string {
		return this.loginName;
	}

	/**
	 * Description: 
	 * APIL Type: string
	 */
	set LoginName(value: string) {
		this.loginName = value;
	}

	protected roles: string[];
	/**
	 * Description: 
	 * APIL Type: Collection<string>
	 */
	get Roles(): string[] {
		return this.roles;
	}

	/**
	 * Description: 
	 * APIL Type: Collection<string>
	 */
	set Roles(value: string[]) {
		this.roles = value;
	}

	protected success: boolean;
	/**
	 * Description: 
	 * APIL Type: boolean
	 */
	get Success(): boolean {
		return this.success;
	}

	/**
	 * Description: 
	 * APIL Type: boolean
	 */
	set Success(value: boolean) {
		this.success = value;
	}

	protected messages: AdacResultMessageApi[];
	/**
	 * Description: 
	 * APIL Type: Collection<ADAC.Internet.Types.AdacResultMessage>
	 */
	get Messages(): AdacResultMessageApi[] {
		return this.messages;
	}

	/**
	 * Description: 
	 * APIL Type: Collection<ADAC.Internet.Types.AdacResultMessage>
	 */
	set Messages(value: AdacResultMessageApi[]) {
		this.messages = value;
	}

	/**
	 * Creates a new model object and copies the values from the provided data object (or other application model) to the created model.
	 */
	public static createFromObject(dataObject: { [key: string]: any }): AdacIdentityModelApi {
		return AppUtils.Helper.createFromMap(dataObject, AdacIdentityModelApi, (key, value) => {
			switch (key.toLowerCase()) {
				case 'userdata':
					return IUserExtApi.createFromObject(value);
				case 'messages':
					const resultmessages = new Array<AdacResultMessageApi>();
					if (value && Array.isArray(value)) {
						value.forEach((v: any) => {
							resultmessages.push(AdacResultMessageApi.createFromObject(v));
						});
					}
					return resultmessages;
				default:
					return value;
			}
		});
	}

	public toRequestObject(): { [key: string]: any } {
		const result: { [key: string]: any } = {};
		if (this.userData) {
			result.UserData = this.userData.toRequestObject();
		}
		result.ID = this.iD;
		result.MglNo = this.mglNo;
		result.LoginName = this.loginName;
		result.Roles = this.roles;
		result.Success = this.success;
		const messagesArrayReqObject: object[] = [];
		this.messages.forEach((element) => {
			messagesArrayReqObject.push(element.toRequestObject());
		});
		result.Messages = messagesArrayReqObject;
		return result;
	}

	public toJsonString(): string {
		return JSON.stringify(this.toRequestObject());
	}
}